import { FormGroup } from "@angular/forms";
import moment from "moment";

export class FormUtil {
  static updateDateConstraints(groupId: number, resetDate: boolean, componentRef: any): void {
    const selectedGroup = componentRef.data.groups.find((group) => group.id === groupId);
    if (selectedGroup) {
      componentRef.minStartDate = new Date(selectedGroup.startDate);
      componentRef.maxEndDate = new Date(selectedGroup.endDate);
      if (resetDate) {
        componentRef.addEventForm.patchValue({
          startDate: null,
          endDate: null,
        });
      }
    }
  }

  static resetMilestonesDatesIfOutOfRange(form: FormGroup, startDateField: string, endDateField: string, datesToCheck: string[]): void {
    const startDate = form.get(startDateField)?.value;
    const endDate = form.get(endDateField)?.value;

    for (let dateField of datesToCheck) {
      if (form.get(dateField).value) {
        const dateValue = moment(form.get(dateField).value);
        if (dateValue?.isBefore(startDate) || dateValue?.isAfter(endDate)) {
          form.get(dateField).setValue(null);
        }
      }
    }
  }
}

